var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c-btn",style:(_vm.rootStyle),attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.onClick,"mousedown":_vm.onMouseDown,"mouseup":_vm.onMouseUp,"mouseleave":_vm.onMouseUp}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }